import { isCarvanaNativeApp, isAndroid as isAndroidNative } from '../is-native-app';

/**
 * Check if the device is using Native Web View.
 */
export function isNativeWebView(): boolean {
  return isCarvanaNativeApp();
}

/**
 * Check if the device is Android.
 */
export function isAndroid(): boolean {
  return isAndroidNative();
}

/**
 * Check if the device is iPhone, iPad, or iPod.
 * Includes iPadOS 13+ which reports as "Macintosh" with touch support.
 */
export function isIOS(): boolean {
  const ua = navigator.userAgent;

  const iOS = /iPhone|iPad|iPod/i.test(ua);
  const iPadOS13Plus = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;

  return iOS || iPadOS13Plus;
}

/**
 * Check if the device is mobile (Android or iOS).
 */
export function isMobile(): boolean {
  return isAndroid() || isIOS();
}

/**
 * Check if the device is desktop (not Android or iOS).
 */
export function isDesktop(): boolean {
  return !isMobile();
}
